import React from 'react'
import {
    Route,
    Redirect,
} from 'react-router-dom'

function checkPath(path){
    console.log(path)
    return true
}

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        localStorage.getItem('kokos_userdata') && (JSON.parse(localStorage.getItem('kokos_userdata')).is_active) ?
            (JSON.parse(localStorage.getItem('kokos_userdata')).role_code == 'ADMN' || JSON.parse(localStorage.getItem('kokos_userdata')).role_code == 'STDADMN') ?
                <Component {...props} />
                : (checkPath(props)) && (JSON.parse(localStorage.getItem('kokos_userdata')).role_code == 'SADMN') ?
                    <Component {...props} />
                    :
                    <Redirect to={{
                        pathname: '/',
                        state: { from: props.location }
                    }} />
            : <Redirect to={{
                pathname: '/',
                state: { from: props.location }
            }} />
    )} />
)

export default PrivateRoute;
